"use strict";
/* eslint-env browser */
// We use cryptographically strong PRNGs (window.crypto.getRandomValues())
// when available. If these PRNGs fail, we fall back to the Alea PRNG, which is
// not cryptographically strong, and we seed it with various sources
// such as the date, Math.random, and window size on the client.
// When using window.crypto.getRandomValues() or alea, the primitive is fraction
// and we use that to construct hex string.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BrowserRandomGenerator_1 = __importDefault(require("./BrowserRandomGenerator"));
const createAleaGenerator_1 = __importDefault(require("./createAleaGenerator"));
const createRandom_1 = __importDefault(require("./createRandom"));
let generator;
if (typeof window !== 'undefined' &&
    window.crypto &&
    typeof window.crypto.getRandomValues === 'function') {
    generator = new BrowserRandomGenerator_1.default();
}
else {
    // On IE 10 and below, there's no browser crypto API
    // available. Fall back to Alea
    //
    // XXX looks like at the moment, we use Alea in IE 11 as well,
    // which has `window.msCrypto` instead of `window.crypto`.
    generator = (0, createAleaGenerator_1.default)();
}
const Random = (0, createRandom_1.default)(generator);
exports.default = Random;
//# sourceMappingURL=main_client.js.map